import React, { Fragment, useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import { Nav, NavItem, NavLink, TabContent, TabPane, Col, Container, Row, CardBody, Card, Button, ButtonGroup } from 'reactstrap';
import AudioReactRecorder, { RecordState } from 'audio-react-recorder';
import classnames from 'classnames';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDotCircle, faStopCircle, faStop, faSave, faPlay, faDownload, faPause } from "@fortawesome/free-solid-svg-icons";
import Spinner from 'react-bootstrap/Spinner';
import Tooltip from '@material-ui/core/Tooltip';
import WaveSurfer from "wavesurfer.js";
import MicrophonePlugin from "wavesurfer.js/dist/plugin/wavesurfer.microphone.js";
import TimelinePlugin from "wavesurfer.js/dist/plugin/wavesurfer.timeline.js";
import lamejs from "lamejs";
import { style } from 'wavesurfer.js/src/util';
import { validateConfigurationsTypeNotification } from '../Notifications/api/NotificationsUser';
import { NotificationsAPI } from '../Notifications/api/NotificationsAPI';
import { HTMLNotification } from '../Notifications/components/HTMLNotification';
import NotificationsSockets from '../Notifications/api/NotificationsSockets';
import moment from 'moment';

var mediaRecorder;
let ws;
let audioCunks = [];

const AudioPanel = ({ id_admision, id_historia }) => {

    //Tab 1 - Listado de Grabaciones
    const [loading, setLoading] = useState(false);
    const [admisionAudios, setAdmisionAudios] = useState([]);

    //Tab 2 - Panel de Grabacion
    const [recordState, setRecordState] = useState(null);
    const [userMedia, setUserMedia] = useState(false);

    const [activeTab, setActiveTab] = useState('1');

    useEffect(() => {
        validateMediaDevice();
        listAudio();
    }, []);

    //Carga las Ondas de Sonido
    const loadWs = () => {
        ws = WaveSurfer.create({
            container: "#waveform",
            waveColor: "#46a6d8",
            progressColor: "#46a6d8",
            barWidth: 3,
            barGap: 2,
            width: '100%',
            height: 40,
            cursorWidth: 1,
            cursorColor: "black",
            responsive: true,
            normalize: true,
            fillParent: true,
            hideScrollbar: true,
            plugins: [
                MicrophonePlugin.create({
                    bufferSize: 256,
                    constraints: { audio: true, video: false },
                    numberOfInputChannels: 1,
                    numberOfOutputChannels: 1
                })
            ]
        });

        ws.microphone.on("deviceReady", function (stream) {
            mediaRecorder = new MediaRecorder(stream);

            mediaRecorder.ondataavailable = function (e) {
                audioCunks.push(e.data);
                ws.loadBlob(new Blob(audioCunks));
            };

            mediaRecorder.onstop = () => {
                ws.loadBlob(new Blob(audioCunks));
            };

            mediaRecorder.start(250);
        });

        ws.microphone.on("deviceError", function (code) {
            console.warn("Device error: " + code);
        });

        ws.on("ready", function () {

        });

        ws.on("finish", function () {
            setRecordState("STOP");
        });
    }

    const cleanWS = () => {
        ws.destroy();
        loadWs();
    }

    //Inicia la Grabacion
    const startRecording = () => {
        audioCunks = [];
        ws && ws.destroy();
        loadWs();
        ws.microphone.start();
        ws.microphone.play();
    }

    //Para la grabacion
    const stopRecording = () => {
        if (!ws) {
            return;
        }
        ws.microphone.stop();
        mediaRecorder && mediaRecorder.state !== "inactive" && mediaRecorder.stop();
    }

    //Reproduce el Audio
    const playAudio = () => {
        if (!ws) {
            return;
        }
        ws.play();
        ws.setVolume(1);
    }

    //Pausa el Audio
    const pauseAudio = () => {
        if (!ws) {
            return;
        }
        ws.pause();
    }

    //Trae la Metadata del Audio en MP3
    const getDataMP3 = async () => {
        if (audioCunks.length > 0) {
            const mp3Blob = await analyzeAudioBuffer(ws.backend.buffer);
            let mp3Data = {
                blob: mp3Blob,
                url: URL.createObjectURL(mp3Blob)
            }
            return mp3Data;
        }
    }

    //Genera la Metadata en WAV y luego a MP3 dependiendo del AudioBuffer
    const analyzeAudioBuffer = (aBuffer) => {
        let numOfChan = aBuffer.numberOfChannels;
        let btwLength = aBuffer.length * numOfChan * 2 + 44;
        let btwArrBuff = new ArrayBuffer(btwLength);
        let btwView = new DataView(btwArrBuff);
        let btwChnls = [];
        let btwIndex;
        let btwSample;
        let btwOffset = 0;
        let btwPos = 0;

        setUint32(0x46464952); // "RIFF"
        setUint32(btwLength - 8); // file length - 8
        setUint32(0x45564157); // "WAVE"
        setUint32(0x20746d66); // "fmt " chunk
        setUint32(16); // length = 16
        setUint16(1); // PCM (uncompressed)
        setUint16(numOfChan);
        setUint32(aBuffer.sampleRate);
        setUint32(aBuffer.sampleRate * 2 * numOfChan); // avg. bytes/sec
        setUint16(numOfChan * 2); // block-align
        setUint16(16); // 16-bit
        setUint32(0x61746164); // "data" - chunk
        setUint32(btwLength - btwPos - 4); // chunk length

        for (btwIndex = 0; btwIndex < aBuffer.numberOfChannels; btwIndex++) {
            btwChnls.push(aBuffer.getChannelData(btwIndex));
        }

        while (btwPos < btwLength) {
            for (btwIndex = 0; btwIndex < numOfChan; btwIndex++) {
                // interleave btwChnls
                btwSample = Math.max(-1, Math.min(1, btwChnls[btwIndex][btwOffset])); // clamp
                btwSample =
                    (0.5 + btwSample < 0 ? btwSample * 32768 : btwSample * 32767) | 0; // scale to 16-bit signed int
                btwView.setInt16(btwPos, btwSample, true); // write 16-bit sample
                btwPos += 2;
            }
            btwOffset++; // next source sample
        }

        let wavHdr = lamejs.WavHeader.readHeader(new DataView(btwArrBuff));

        //Stereo
        let data = new Int16Array(btwArrBuff, wavHdr.dataOffset, wavHdr.dataLen / 2);
        let leftData = [];
        let rightData = [];
        for (let i = 0; i < data.length; i += 2) {
            leftData.push(data[i]);
            rightData.push(data[i + 1]);
        }
        var left = new Int16Array(leftData);
        var right = new Int16Array(rightData);

        console.log(wavHdr.channels);
        if (wavHdr.channels === 2) {//STEREO

            console.log("Stereo");
            var mp3BufferData = new Promise(function (resolve, reject) {
                resolve(bufferToMp3(wavHdr.channels, wavHdr.sampleRate, left, right));
            });
            return mp3BufferData;
        }
        else if (wavHdr.channels === 1) {  //MONO

            console.log("Mono");
            var mp3BufferData = new Promise(function (resolve, reject) {
                resolve(bufferToMp3(wavHdr.channels, wavHdr.sampleRate, data));
            });
            return mp3BufferData;
        }

        function setUint16(data) {
            btwView.setUint16(btwPos, data, true);
            btwPos += 2;
        }

        function setUint32(data) {
            btwView.setUint32(btwPos, data, true);
            btwPos += 4;
        }
    }

    //Realiza el Buffer a MP3
    const bufferToMp3 = (channels, sampleRate, left, right = null) => {
        let audioChannels = channels;
        let sampleRateAudio = 48000;
        const buffer = [];
        const samplesPerFrame = 1152;
        const mp3enc = new lamejs.Mp3Encoder(audioChannels, sampleRateAudio, 128);
        let remaining = left.length;
        let mp3buf = [];
        for (let i = 0; remaining >= samplesPerFrame; i += samplesPerFrame) {
            if (!right) {
                let mono = left.subarray(i, i + samplesPerFrame);
                mp3buf = mp3enc.encodeBuffer(mono);
            }
            else {
                let leftChunk = left.subarray(i, i + samplesPerFrame);
                let rightChunk = right.subarray(i, i + samplesPerFrame);
                mp3buf = mp3enc.encodeBuffer(leftChunk, rightChunk);
            }
            if (mp3buf.length > 0) {
                buffer.push(mp3buf);
            }
            remaining -= samplesPerFrame;
        }
        const d = mp3enc.flush();
        if (d.length > 0) {
            buffer.push(new Int8Array(d));
        }
        var mp3Blob = new Blob(buffer, { type: "audio/mp3" });
        return mp3Blob;
    }



    const start = () => {
        try {
            document.getElementById("waveform").style.visibility = "visible";
            startRecording();
            setRecordState("START_RECORD");
        }
        catch (err) {
            console.log(err);
        }
    }

    const stop = async () => {
        await stopRecorder();
    }

    const stopRecorder = async () => {
        setRecordState("STOP");
        stopRecording();
    }

    const playRP = () => {
        playAudio();
        setRecordState("START_RP");
    }

    const stopRP = () => {
        ws.stop();
        setRecordState("STOP");
    }

    const pauseRP = () => {
        setRecordState("STOP");
        pauseAudio();
    }

    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    const validateMediaDevice = () => {
        navigator.mediaDevices.getUserMedia({ audio: true }).then(function (mediaStream) {
            setUserMedia(true);
            loadWs();
        }).catch(function (err) {
            console.log(err);
            setUserMedia(false);
        });
    }

    const saveAudio = async () => {
        setLoading(true);
        await getDataMP3().then((res) => {
            fetchAudio(res);
        }).catch((error) => {
            console.log(error);
        });
    }

    const fetchAudio = async (audioData) => {
        try {
            if(audioData.blob.size <= 384){
                alert("El audio no se grabo bien, por favor grabe nuevamente");
                setLoading(false);
                return;
            }
            if (audioData != null) {
                var _dataAud = new FormData();
                _dataAud.append("id_admision", id_admision);
                _dataAud.append('grabacion', audioData.blob, id_admision + "audNew.mp3");
                _dataAud.append("transcripcion", null);
                _dataAud.append("id_usuario", JSON.parse(sessionStorage.getItem('usuario')).id_usuario);
                fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-audios/create', {
                    method: 'POST',
                    headers: {
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: _dataAud
                }).then(response => {
                    if (response.status != 500 && response.status != 403) {
                        setLoading(false);
                        refresh();
                        cleanWS();
                        notifyAllTranscriptorsUsers();
                    }
                    else {
                        throw new Error("Ha ocurrido un error");
                    }
                }).catch(error => {
                    console.error(error);
                    setLoading(false);
                });
            }
            else {
                setLoading(false);
                alert("No se ha grabado ningun audio");
                return;
            }
        }
        catch (err) {
            setLoading(false);
            console.log(err);
        }
    }

    const notifyAllTranscriptorsUsers = async () => {
        await validateConfigurationsTypeNotification(5).then((notData) => {            
            for (let i = 0; i < notData.length; i++) {
                let usuario_conectado = JSON.parse(sessionStorage.getItem('usuario'));
                let remitente = usuario_conectado.nombre.split(' ')[0] + ' ' + usuario_conectado.nombre.split(' ')[1];
                let fecha_notificacion = moment().tz("America/Bogota").format("YYYY-MM-DD HH:mm:ss");
                var notification = new NotificationsAPI();
                notification.vista = false;
                notification.id_usuario = notData[i].id_usuario;
                notification.id_admision = id_admision;
                notification.id_historia = id_historia;
                notification.asunto = remitente + " ha grabado un audio en la admisión " + id_admision;
                notification.remitente = remitente;
                notification.notificacion = remitente + " ha grabado un audio en la admisión " + id_admision;
                notification.id_notificaciones_tipo = 5;
                notification.fecha_notificacion = fecha_notificacion;

                notification.addNotification().then((not) => {
                    console.log("notificationData", not);
                    let htmlNotificacion = new HTMLNotification();
                    notification.id_notificacion = not.notificacion.id_notificacion;//id_notificacion
                    notification.html_notificacion = htmlNotificacion.notificationAudioDoctorToTranscriptor(fecha_notificacion, notification, "");

                    console.log("htmlNoti", notification.html_notificacion);

                    notification.sendHTMLNotification().then((res_not) => {
                        NotificationsSockets.sendNotification(notification);
                        return res_not;
                    }).catch((err) => {
                        console.log(err);
                        return false;
                    });
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    const listAudio = async () => {
        setLoading(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision-audios/listar?id_admision=' + id_admision, {
            method: 'GET',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error");
            }
        }).then(res => {
            setAdmisionAudios(res);
            setLoading(false);
        }).catch(error => {
            console.log(error);
            setAdmisionAudios([]);
            setLoading(false);
        });
    }

    const cleanPanel = () => {
        setRecordState(null);
    }

    const refresh = async () => {
        await cleanPanel();
        await toggle('1');
        await listAudio();
    }

    return (
        <Fragment>
            {
                userMedia == true ? <>
                    <div id="waveform" style={{ visibility: 'hidden' }}></div>
                    <ButtonGroup style={{ marginTop: 5, }}>
                        <Tooltip title="Grabar">
                            <Button
                                className="btn-sm"
                                disabled={recordState == "START_RECORD" || recordState == "START_RP"}
                                style={{ marginTop: 5 }}
                                color="success"
                                onClick={() => start()}>
                                <FontAwesomeIcon className="text-white" icon={faDotCircle} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Parar Grabación ">
                            <Button
                                className="btn-sm"
                                disabled={recordState == "STOP" || recordState == null || recordState == "START_RP"}
                                style={{ marginTop: 5 }}
                                color="danger"
                                onClick={() => stop()}>
                                <FontAwesomeIcon className="text-white" icon={faStopCircle} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Parar Audio">
                            <Button disabled={recordState == "STOP" || recordState == null || recordState == "START_RECORD"}
                                style={{ marginTop: 5 }}
                                color="danger"
                                onClick={() => stopRP()}>
                                <FontAwesomeIcon className="text-white" icon={faStop} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Reproducir Audio">
                            <Button disabled={recordState == "START_RECORD" || recordState == null || recordState == "START_RP"}
                                style={{ marginTop: 5 }}
                                color="success"
                                onClick={() => playRP()}>
                                <FontAwesomeIcon className="text-white" icon={faPlay} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Guardar Audio">
                            <Button
                                disabled={recordState == "START_RECORD" || recordState == null}
                                style={{ marginTop: 5 }}
                                color="primary"
                                onClick={() => saveAudio()}>
                                <FontAwesomeIcon className="text-white" icon={faSave} />
                            </Button>
                        </Tooltip>
                        {
                            loading == false ? null
                                :
                                <div className="text-center">
                                    <Spinner animation="border" variant="success" />
                                </div>
                        }
                    </ButtonGroup>
                </> : <>
                    <div className="text-center" style={{ display: 'flex', flexDirection: 'row', }}>
                        <b class="text-danger">Debe habilitar los Permisos de su microfono para usar esta opción</b>
                    </div>
                </>
            }
        </Fragment >)
}

export default AudioPanel;